import React from "react";
import ApplyNow from "components/ApplyNow";
import styles from "./index.module.scss";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";
import purpleBG from "assets/images/purple-bg.png"

const CareerInfo = ({ children }) => {
  const { dir, language } = useAppSelector(getSettings);

  return (
    <div className={""} dir={dir} lang={language}>
      <h2
        className={`text-white lg:text-theme-purple text-2xl font-medium text-opacity-100 pt-1 w-full rtl:pr-4 lg:text-opacity-80 ltr:pl-4 mt-6 lg:mt-0 relative`}
      >
        <img src={purpleBG} className="lg:hidden block absolute top-[1px] left-0 w-full h-14 z-[-1]" dir={dir}
        style={{
          transform: "rotateY(180deg)",
        }}
        />
        {t("careerInfo")}
      </h2>
      <div className={`${styles["career-info-container"]} | container  pt-3`}>
        {children}
      </div>
      <ApplyNow />
    </div>
  );
};

export default CareerInfo;
